import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon
    {...props}
    width="120"
    height="138"
    viewBox="0 0 120 138"
    fill="none"
  >
    <ellipse cx="59" cy="90.1111" rx="44" ry="30.5556" fill="#0B8735" />
    <ellipse cx="59" cy="85.2222" rx="44" ry="30.5556" fill="#0CB746" />
    <path
      d="M49.8127 78.3526C49.2016 76.5191 50.0674 70.4583 50.5767 67.6572L57.0703 68.0391C56.8157 70.713 56.1536 76.5191 55.5424 78.3526C54.7785 80.6444 50.5767 80.6444 49.8127 78.3526Z"
      fill="#C58C48"
    />
    <path
      d="M70.6114 73.0048C71.2226 71.1713 70.3567 65.1106 69.8474 62.3094L63.3538 62.6914C63.6085 65.3653 64.2706 71.1713 64.8817 73.0048C65.6457 75.2967 69.8474 75.2967 70.6114 73.0048Z"
      fill="#B17834"
    />
    <path
      d="M40.1279 48.9777C42.6357 45.7984 45.6393 44.5198 47.1169 44.2751C50.1965 43.6133 50.9091 45.1658 48.9367 47.0111C47.6662 48.1997 46.0795 51.4426 45.0733 53.7771C44.663 54.729 43.9798 55.6315 42.99 55.9392C42.3259 56.1457 41.5064 56.2371 40.6145 55.9065C40.4388 55.8413 40.2741 55.7617 40.1199 55.6704C37.8809 54.3455 38.5167 51.0203 40.1279 48.9777Z"
      fill="#C58C48"
    />
    <path
      d="M40.2698 48.5671C42.7669 45.7892 45.1954 44.5932 47.1169 44.275C50.1965 43.6132 50.8862 44.7396 49.6862 47.1594C48.7359 49.0754 47.0302 49.9388 46.1946 52.0767C45.6771 52.3143 45.0054 50.2072 43.1933 49.5354C41.3812 48.8635 40.3759 49.2076 40.2698 48.5671Z"
      fill="#C14177"
    />
    <path
      d="M45.868 63.4081C46.3237 57.3472 48.1888 51.9507 49.6999 48.688C50.2978 47.3971 51.6233 46.6483 53.046 46.6483H66.3512C67.3702 46.6483 68.3735 47.0191 69.0075 47.8167C72.133 51.7492 73.2024 58.1152 73.6908 62.9642C73.9247 65.2857 72.0542 67.2751 69.7209 67.2751H49.6517C47.4944 67.2751 45.7062 65.5593 45.868 63.4081Z"
      fill="#D46996"
    />
    <path
      d="M45.7717 65.4009C45.8342 62.4152 46.2692 59.5472 46.8789 56.9618C52.2764 60.7815 68.3195 60.3995 72.7942 56.9618C73.4135 59.8924 73.6995 62.8209 73.8841 65.1266C73.9915 66.4679 73.3812 67.7512 72.1231 68.2284C70.0982 68.9964 66.3 69.949 59.916 69.949C53.2463 69.949 49.399 68.9092 47.4476 68.1265C46.3454 67.6843 45.7469 66.5883 45.7717 65.4009Z"
      fill="#2F6B96"
    />
    <path
      d="M75.6757 53.4042C74.2556 49.6121 71.7843 47.4793 70.4514 46.7961C67.7198 45.2277 66.5681 46.4893 67.8847 48.8477C68.7327 50.3668 69.2562 53.939 69.5034 56.469C69.6042 57.5007 69.98 58.5684 70.8291 59.163C71.3987 59.562 72.1514 59.8987 73.1017 59.8554C73.2889 59.8469 73.47 59.8212 73.6447 59.7813C76.1808 59.2014 76.5882 55.8405 75.6757 53.4042Z"
      fill="#C58C48"
    />
    <path
      d="M75.6656 52.97C74.1335 49.5635 72.1847 47.6845 70.4514 46.7961C67.7198 45.2277 66.7197 46.0904 67.1257 48.7607C67.4471 50.8751 68.8087 52.2171 68.9534 54.508C69.3739 54.8919 70.6555 53.0896 72.5862 53.0017C74.5169 52.9138 75.3695 53.5477 75.6656 52.97Z"
      fill="#C14177"
    />
    <circle
      cx="75.6383"
      cy="31.8125"
      r="4.20176"
      transform="rotate(20.5422 75.6383 31.8125)"
      fill="#2C3048"
    />
    <circle
      cx="69.5266"
      cy="23.409"
      r="4.20176"
      transform="rotate(20.5422 69.5266 23.409)"
      fill="#2C3048"
    />
    <circle
      cx="4.20176"
      cy="4.20176"
      r="4.20176"
      transform="matrix(-0.936414 0.350898 0.350898 0.936414 44.4845 26.4035)"
      fill="#2C3048"
    />
    <circle
      cx="4.20176"
      cy="4.20176"
      r="4.20176"
      transform="matrix(-0.936414 0.350898 0.350898 0.936414 50.5961 18)"
      fill="#2C3048"
    />
    <path
      d="M40.817 37.8628C40.817 35.4181 43.1089 35.0616 44.2548 35.1889L45.4008 41.6826C43.4909 41.6826 40.817 40.9186 40.817 37.8628Z"
      fill="#B17834"
    />
    <path
      d="M77.105 37.8628C77.105 35.4181 74.8131 35.0616 73.6672 35.1889L72.5212 41.6826C74.4311 41.6826 77.105 40.9186 77.105 37.8628Z"
      fill="#B17834"
    />
    <path
      d="M73.6671 36.3349C73.6671 44.3515 67.8413 50.0862 58.77 50.0862C49.6987 50.0862 43.8729 44.3515 43.8729 36.3349C43.8729 28.3184 49.6987 22.5837 58.77 22.5837C67.8413 22.5837 73.6671 28.3184 73.6671 36.3349Z"
      fill="#C58C48"
    />
    <path
      d="M73.6671 36.3349C70.2293 28.3134 60.2979 32.5151 58.77 29.0773C57.2421 32.5151 48.8386 26.7855 43.8728 36.3349C41.199 28.3134 52.6583 19.9099 58.77 22.5837C64.8816 20.2918 76.341 28.6954 73.6671 36.3349Z"
      fill="#2C3253"
    />
    <path
      d="M32 79.5229C30.8333 79.3563 28.4 78.2229 28 75.0229C29.3333 74.8563 32 75.5229 32 79.5229Z"
      fill="#00A337"
    />
    <path
      d="M32 79.5229C32.875 79.4124 34.7 78.6607 35 76.5382C34 76.4276 32 76.8698 32 79.5229Z"
      fill="#00A337"
    />
    <path
      d="M87.4793 96.9354C88.6205 96.6415 90.9144 95.2474 90.96 92.0228C89.6165 92.0038 87.0393 92.9597 87.4793 96.9354Z"
      fill="#00A337"
    />
    <path
      d="M87.4792 96.9355C86.5974 96.9218 84.7008 96.3754 84.1692 94.2988C85.1509 94.0789 87.1874 94.2984 87.4792 96.9355Z"
      fill="#00A337"
    />
    <path
      d="M82.2275 71.8942C83.3941 71.7275 85.8275 70.5942 86.2275 67.3942C84.8941 67.2275 82.2275 67.8942 82.2275 71.8942Z"
      fill="#00A337"
    />
    <path
      d="M82 72C80.8333 71.8526 78.4 70.8503 78 68.0203C79.3333 67.8729 82 68.4625 82 72Z"
      fill="#00A337"
    />
    <path
      d="M57.2275 106.523C58.3941 106.356 60.8275 105.223 61.2275 102.023C59.8941 101.856 57.2275 102.523 57.2275 106.523Z"
      fill="#00A337"
    />
    <path
      d="M57 106.629C55.8333 106.481 53.4 105.479 53 102.649C54.3333 102.502 57 103.091 57 106.629Z"
      fill="#00A337"
    />
  </SvgIcon>
));
